import type { UserInfo } from '@/types';

/**
 * UP-25 (2026-05-25): single-source helper для отображения имени юзера.
 *
 * Раньше fallback-цепочка дублировалась в Header (3 места) и Dashboard.
 * UP-18 fix покрывал только меню выхода → regression: Dashboard greeting +
 * Header top-right показывали "Пользователь" даже когда firstName/lastName
 * заполнены. Этот helper — единая точка истины fallback chain'а.
 *
 * Priority order:
 *   1. firstName + lastName (combined, trimmed) — оба, либо один из них
 *   2. firstName — если firstName не пуст
 *   3. lastName — fallback на одну фамилию без имени
 *   4. username — VK/Telegram handle
 *   5. fallback string (caller передаёт локализованную «Пользователь»)
 */
export function resolveDisplayName(
  user: Pick<UserInfo, 'firstName' | 'lastName' | 'username'> | null | undefined,
  fallback: string,
): string {
  if (!user) return fallback;
  const first = user.firstName?.trim();
  const last = user.lastName?.trim();
  if (first || last) {
    return `${first ?? ''} ${last ?? ''}`.trim();
  }
  const username = user.username?.trim();
  if (username) return username;
  return fallback;
}
